<template>
  <div class="flex flex-col lg:flex-row lg:space-x-6 mr-6 w-full">
    <div
      class="bg-white rounded-xl rounded-tl-none shadow w-full py-16 px-12 lg:p-16 mb-12 lg:mb-0"
    >
      <!-- Content header -->
      <div class="flex flex-row justify-between items-center">
        <div class="mr-4">
          <h2 class="capitalize">{{ viewTitle }}</h2>
          <div v-if="loadedData" class="mb-2">
            <p class="text-xs italic">
              Subscriber limit:
              <span :class="subscribersCountClasses">{{
                subscribersCount
              }}</span>
              / {{ subscribersCountLimit }}
            </p>
          </div>
          <div>
            <a class="flex flex-row w-full" @click="toggleView">
              <!--
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="self-center mr-2 w-4 h-4">
                <path stroke-linecap="round" stroke-linejoin="round" d="M7.5 21L3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5" />
                </svg> 
              -->
              View {{ activeViewId ? 'all ' : ''
              }}{{ views[+!activeViewId].title }}
            </a>
          </div>
        </div>
        <div class="flex flex-col">
          <div class="flex flex-row h-16 self-center">
            <div
              v-if="!!selectedSubscribers.length"
              class="flex items-center mr-6"
            >
              <t-dropdown>
                <template
                  #trigger="{
                    mousedownHandler,
                    focusHandler,
                    blurHandler,
                    keydownHandler,
                  }"
                >
                  <button
                    class="flex items-center justify-between self-center text-white block px-4 py-2 transition duration-100 ease-in-out border border-transparent rounded-md shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed btn btn-primary btn-inverted mb-0"
                    @mousedown="mousedownHandler"
                    @focus="focusHandler"
                    @blur="blurHandler"
                    @keydown="keydownHandler"
                  >
                    <span>{{ subscribersBulkActionsText }}</span>
                    <div>
                      <svg
                        viewBox="0 0 20 20"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        class="fill-current h-3 w-3 ml-2"
                      >
                        <g
                          id="Page-13"
                          stroke="none"
                          stroke-width="1"
                          fill="currentColor"
                          fill-rule="evenodd"
                        >
                          <g id="icon-shape">
                            <path d="M19 9l-7 7-7-7"></path>
                          </g>
                        </g>
                      </svg>
                    </div>
                  </button>
                </template>
                <template #default="{ blurHandler }">
                  <div
                    v-for="(opt, index) in subscribersBulkActions"
                    :key="index"
                  >
                    <button
                      class="text-left block w-full px-4 py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                      role="menuitem"
                      @blur="blurHandler"
                      @click="dispatchAction(opt.action)"
                    >
                      {{ opt.title }}
                    </button>
                  </div>
                </template>
              </t-dropdown>
            </div>
            <div class="h-full mr-6">
              <button
                title="Reset data, search, filters, sorting and selections"
                class="transform hover:rotate-180 transition-all duration-300 h-full self-center"
                @click="init"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6 hover:text-primary"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
                  />
                </svg>
              </button>
            </div>
            <div
              :class="[
                'flex items-center flex-wrap lg:flex-nowrap relative border-2 border-truegray-300 rounded-xl text-black w-100',
                { 'mr-6': activeViewId },
              ]"
            >
              <t-dropdown class="h-full">
                <template
                  #trigger="{
                    mousedownHandler,
                    focusHandler,
                    blurHandler,
                    keydownHandler,
                  }"
                >
                  <button
                    class="flex items-center justify-between block px-4 transition duration-100 ease-in-out rounded-md shadow-sm focus:outline-none btn text-truegray-700 w-11/12 mb-0 py-2 h-full"
                    @mousedown="mousedownHandler"
                    @focus="focusHandler"
                    @blur="blurHandler"
                    @keydown="keydownHandler"
                  >
                    <span>{{
                      includeSearchFilter ? 'Include' : 'Exclude'
                    }}</span>
                    <div>
                      <svg
                        viewBox="0 0 20 20"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        class="fill-current h-3 w-3 ml-2"
                      >
                        <g
                          id="Page-13"
                          stroke="none"
                          stroke-width="1"
                          fill="currentColor"
                          fill-rule="evenodd"
                        >
                          <g id="icon-shape">
                            <path d="M19 9l-7 7-7-7"></path>
                          </g>
                        </g>
                      </svg>
                    </div>
                  </button>
                </template>
                <template #default="{ blurHandler }">
                  <div>
                    <button
                      class="text-left block w-full px-4 py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                      role="menuitem"
                      @blur="blurHandler"
                      @click="setIncludeSearchFilter(true)"
                    >
                      Include
                    </button>
                  </div>
                  <div>
                    <button
                      class="text-left block w-full px-4 py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                      role="menuitem"
                      @blur="blurHandler"
                      @click="setIncludeSearchFilter(false)"
                    >
                      Exclude
                    </button>
                  </div>
                </template>
              </t-dropdown>
              <TextInput
                :value="searchFilter"
                :label="`${includeSearchFilter ? 'Include' : 'Exclude'}...`"
                :placeholder="searchFilterPlaceholder"
                :textarea="false"
                :placeholder_black="true"
                :fixed_width="true"
                :margin_bottom="false"
                :search_icon="true"
                :border_enabled="false"
                :response_selection_id="'updateSubscribersSearchFilter'"
              />
              <div
                v-if="!activeViewId"
                class="w-px h-10 relative bg-truegray-300 hidden lg:block"
              ></div>
              <div v-if="!activeViewId">
                <button
                  class="bg-white h-10 flex items-center w-full lg:w-auto justify-center hover:text-primary pl-4 pr-8 flex-shrink-0"
                  @click="() => setFiltersOpen()"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4 mr-2 flex-shrink-0"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      d="M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z"
                    />
                  </svg>
                  Filters
                  <div
                    :style="[{ fontSize: '0.5rem' }]"
                    class="ml-2 rounded-full bg-primary text-white font-bold h-4 w-4 flex items-center justify-center"
                    :class="filtersCount ? 'visible' : 'invisible'"
                  >
                    {{ filtersCount }}
                  </div>
                </button>
              </div>
              <div
                :class="
                  filtersOpen
                    ? 'transition-all duration-300 ease-in-out'
                    : 'h-0 opacity-0 pointer-events-none'
                "
                class="absolute left-0 top-20 bg-white rounded-xl shadow-xl border border-truegray-300 p-6 z-20 text-black w-full"
              >
                <div class="flex justify-between mb-8 items-center w-full">
                  <h3 class="mb-0">Filters</h3>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5 text-truegray-500 hover:text-primary cursor-pointer transform hover:rotate-180 transition-all duration-300 ease-in-out"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    @click="() => setFiltersOpen(false)"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>

                <!-- Filters -->
                <div class="flex flex-col space-y-2 w-full">
                  <InputDropdownExpanding
                    :label="'Subscriber status'"
                    :options="subscriberStatusOptions"
                    :response-selection-id="'updateSubscribersFilterByStatus'"
                    :is-cloud="false"
                    :multiselect="false"
                  />
                  <InputDropdownExpanding
                    :label="'Lists'"
                    :options="mailListInputOptions"
                    :response-selection-id="'updateSubscribersFilterByLists'"
                    :is-cloud="false"
                  />
                </div>

                <div class="flex justify-between mt-4 items-end w-full">
                  <p class="text-primary cursor-pointer" @click="initFilters">
                    Clear Filters
                  </p>
                  <!-- <button @click="initFilters" class="btn btn-black m-0">Save Filters</button> -->
                </div>
              </div>
            </div>
            <div v-if="!!activeViewId && !isCateRegionalAdmin" class="h-full">
              <button
                type="button"
                :disabled="!loadedData"
                :class="[
                  'btn btn-primary h-full mb-0',
                  { 'opacity-25 cursor-not-allowed': !loadedData },
                ]"
                @click="showModal('cw-update')"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6 mr-2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 4.5v15m7.5-7.5h-15"
                  />
                </svg>
                <span>New {{ views[+activeViewId].title.slice(0, -1) }}</span>
              </button>
            </div>
          </div>
          <!-- queue alert -->
          <div
            v-if="showAlert"
            class="flex flex-row items-center justify-end w-full mt-4"
          >
            <div
              class="flex items-center justify-start bg-green-400 text-white rounded px-3 py-2"
            >
              <p class="text-xs mr-2">
                Update queued! Refresh subscribers to see when it is processed.
              </p>

              <button
                class="flex justify-center items-center transform hover:rotate-90 transition-all duration-300 flex-shrink-0 ml-auto"
                @click="() => toggleAlert(false)"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6 flex-shrink-0"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          </div>
          <!-- /queue alert -->
        </div>
      </div>
      <!-- /Content header -->

      <hr class="w-full my-6" />

      <!-- Table -->
      <div
        id="cw-subscribers"
        class="cw-newsletter-table-wrapper flex flex-col px-2 w-full pb-4"
      >
        <template v-if="loadedData">
          <TabLists
            v-if="activeViewId"
            :active-list-id-initial="activeListId"
            :subscribers-headers="subscribersHeaders"
            :get-subscriber-status-chip-config="getSubscriberStatusChipConfig"
            :search-filter="searchFilter"
            :include-search-filter="includeSearchFilter"
            @reset-active-list="resetActiveList"
          />

          <div v-else class="border rounded-md">
            <div :class="['flex items-center border-b p-4 w-full']">
              <!--
                <div 
                v-for="(item, index) in subscribersHeaders" 
                :key="index"
                :class="item.class"
                >
                <div v-if="item.value === 'selected'">
                <t-checkbox
                v-model="selectAll"
                :disabled="!filteredSubscribers.length"
                @change="setSelectAll"
                />
                </div>
                <div v-else class="flex flex-row align-center">
                <div class="mr-2 font-primary">
                {{ item.text }}
                </div>
                <div v-if="item.sort">
                <button class="h-full my-auto text-black hover:text-primary" @click="() => setSubscribersColumnSortBy(item.value)">
                <svg :class="sortBy === item.value && sortDesc ? 'rotate-180' : ''" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-3 h-3 transform transition-all">
                <path fill-rule="evenodd" d="M10 2a.75.75 0 01.75.75v12.59l1.95-2.1a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 111.1-1.02l1.95 2.1V2.75A.75.75 0 0110 2z" clip-rule="evenodd" />
                </svg>
                </button>
                </div>
                </div>
                </div> 
              -->
              <div class="w-4/12 flex items-center">
                <div :class="subscribersHeaders[0].class">
                  <div v-if="subscribersHeaders[0].value === 'selected'">
                    <t-checkbox
                      v-model="selectAll"
                      :disabled="!filteredSubscribers.length"
                      @change="setSelectAll"
                    />
                  </div>
                </div>

                <div :class="[subscribersHeaders[1].class]">
                  <div class="flex flex-row align-center">
                    <div class="mr-2 font-primary">
                      {{ subscribersHeaders[1].text }}
                    </div>
                    <div v-if="subscribersHeaders[1].sort">
                      <button
                        class="h-full my-auto text-black hover:text-primary"
                        @click="
                          () =>
                            setSubscribersColumnSortBy(
                              subscribersHeaders[1].value,
                            )
                        "
                      >
                        <svg
                          :class="
                            sortBy === subscribersHeaders[1].value && sortDesc
                              ? 'rotate-180'
                              : ''
                          "
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          class="w-3 h-3 transform transition-all"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10 2a.75.75 0 01.75.75v12.59l1.95-2.1a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 111.1-1.02l1.95 2.1V2.75A.75.75 0 0110 2z"
                            clip-rule="evenodd"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="w-8/12 flex items-center justify-end space-x-6">
                <div :class="subscribersHeaders[2].class">
                  <div class="flex flex-row align-center">
                    <div class="mr-2 font-primary">
                      {{ subscribersHeaders[2].text }}
                    </div>
                    <div v-if="subscribersHeaders[2].sort">
                      <button
                        class="h-full my-auto text-black hover:text-primary"
                        @click="
                          () =>
                            setSubscribersColumnSortBy(
                              subscribersHeaders[2].value,
                            )
                        "
                      >
                        <svg
                          :class="
                            sortBy === subscribersHeaders[2].value && sortDesc
                              ? 'rotate-180'
                              : ''
                          "
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          class="w-3 h-3 transform transition-all"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10 2a.75.75 0 01.75.75v12.59l1.95-2.1a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 111.1-1.02l1.95 2.1V2.75A.75.75 0 0110 2z"
                            clip-rule="evenodd"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>

                <div :class="subscribersHeaders[3].class">
                  <div class="flex flex-row align-center">
                    <div class="mr-2 font-primary">
                      {{ subscribersHeaders[3].text }}
                    </div>
                    <div v-if="subscribersHeaders[3].sort">
                      <button
                        class="h-full my-auto text-black hover:text-primary"
                        @click="
                          () =>
                            setSubscribersColumnSortBy(
                              subscribersHeaders[3].value,
                            )
                        "
                      >
                        <svg
                          :class="
                            sortBy === subscribersHeaders[3].value && sortDesc
                              ? 'rotate-180'
                              : ''
                          "
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          class="w-3 h-3 transform transition-all"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10 2a.75.75 0 01.75.75v12.59l1.95-2.1a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 111.1-1.02l1.95 2.1V2.75A.75.75 0 0110 2z"
                            clip-rule="evenodd"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>

                <div :class="subscribersHeaders[4].class">
                  <div class="flex flex-row align-center">
                    <div class="mr-2 font-primary">
                      {{ subscribersHeaders[4].text }}
                    </div>
                    <div v-if="subscribersHeaders[4].sort">
                      <button
                        class="h-full my-auto text-black hover:text-primary"
                        @click="
                          () =>
                            setSubscribersColumnSortBy(
                              subscribersHeaders[4].value,
                            )
                        "
                      >
                        <svg
                          :class="
                            sortBy === subscribersHeaders[4].value && sortDesc
                              ? 'rotate-180'
                              : ''
                          "
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          class="w-3 h-3 transform transition-all"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10 2a.75.75 0 01.75.75v12.59l1.95-2.1a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 111.1-1.02l1.95 2.1V2.75A.75.75 0 0110 2z"
                            clip-rule="evenodd"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>

                <div :class="subscribersHeaders[5].class" class="ml-auto w-14">
                  <div class="flex flex-row align-center">
                    <div class="mr-2 font-primary">
                      {{ subscribersHeaders[5].text }}
                    </div>
                    <div v-if="subscribersHeaders[5].sort">
                      <button
                        class="h-full my-auto text-black hover:text-primary"
                        @click="
                          () =>
                            setSubscribersColumnSortBy(
                              subscribersHeaders[5].value,
                            )
                        "
                      >
                        <svg
                          :class="
                            sortBy === subscribersHeaders[5].value && sortDesc
                              ? 'rotate-180'
                              : ''
                          "
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          class="w-3 h-3 transform transition-all"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10 2a.75.75 0 01.75.75v12.59l1.95-2.1a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 111.1-1.02l1.95 2.1V2.75A.75.75 0 0110 2z"
                            clip-rule="evenodd"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <DynamicScroller
              v-if="!!filteredSubscribers.length && !isCateRegionalAdmin"
              :items="filteredSubscribers"
              :min-item-size="54"
              :style="{ maxHeight: '50vh' }"
            >
              <template #default="{ item, index, active }">
                <DynamicScrollerItem
                  :item="item"
                  :active="active"
                  :size-dependencies="[item.lists]"
                  :data-index="index"
                >
                  <div
                    :class="[
                      'flex items-center gap-4 bg-white p-4 py-2 w-full text-left rounded-md z-0 relative',
                      { 'bg-gray-50': item.selected },
                    ]"
                  >
                    <div class="w-4/12 flex items-center">
                      <div class="w-6 flex-shrink-0">
                        <t-checkbox
                          v-model="item.selected"
                          @change="() => toggleSelectSubscriber(index)"
                        />
                      </div>
                      <div class="w-full">
                        <div class="w-10/12 truncate overflow-ellipsis text-xs">
                          {{ item.email }}
                        </div>
                      </div>
                    </div>

                    <div class="w-8/12 flex items-center justify-end space-x-6">
                      <div class="w-24 text-xs text-center">
                        {{ getDateFormatted(item.createdAt) }}
                      </div>
                      <div
                        class="w-60 flex flex-row flex-wrap items-center justify-center max-h-16 gap-2 overflow-y-scroll no-scrollbar"
                      >
                        <div
                          v-for="list in item.lists"
                          :key="list.id"
                          class="flex flex-row items-center gap-2 py-1 px-2 rounded-full border border-primary text-xs text-primary w-auto cursor-pointer hover:bg-truegray-100"
                          @click="routeTo(list.id)"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            class="w-3 h-3 flex-shrink-0"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M3 4.25A2.25 2.25 0 015.25 2h5.5A2.25 2.25 0 0113 4.25v2a.75.75 0 01-1.5 0v-2a.75.75 0 00-.75-.75h-5.5a.75.75 0 00-.75.75v11.5c0 .414.336.75.75.75h5.5a.75.75 0 00.75-.75v-2a.75.75 0 011.5 0v2A2.25 2.25 0 0110.75 18h-5.5A2.25 2.25 0 013 15.75V4.25z"
                              clip-rule="evenodd"
                            />
                            <path
                              fill-rule="evenodd"
                              d="M6 10a.75.75 0 01.75-.75h9.546l-1.048-.943a.75.75 0 111.004-1.114l2.5 2.25a.75.75 0 010 1.114l-2.5 2.25a.75.75 0 11-1.004-1.114l1.048-.943H6.75A.75.75 0 016 10z"
                              clip-rule="evenodd"
                            />
                          </svg>
                          <span>
                            {{ list.name }}
                          </span>
                        </div>
                        <!--
                          <t-dropdown :disabled="!item.lists.length">
                          <template
                          slot="trigger"
                          slot-scope="{ 
                          mousedownHandler,
                          focusHandler,
                          blurHandler,
                          keydownHandler, 
                          }"
                          >
                          <button
                          class="flex items-center justify-between text-white block px-4 py-2 transition duration-100 ease-in-out border border-transparent rounded-md shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed btn btn-primary btn-inverted w-11/12 mb-0 z-0 bg-transparent"
                          @mousedown="mousedownHandler"
                          @focus="focusHandler"
                          @blur="blurHandler"
                          @keydown="keydownHandler"
                          >
                          <span>{{ getListsText(item.lists) }} </span>
                          <div><svg viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="fill-current h-3 w-3 ml-2"><g id="Page-13" stroke="none" stroke-width="1" fill="currentColor" fill-rule="evenodd"><g id="icon-shape"><path d="M19 9l-7 7-7-7"></path></g></g></svg></div>
                          </button>
                          </template> 
                          <template slot-scope="{ blurHandler }">
                          <div v-for="(list, listIndex) in item.lists" :key="listIndex" class="z-10">
                          <button
                          class="text-left block w-full px-4 py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                          role="menuitem"
                          @blur="blurHandler"
                          @click="routeTo(list.id)"
                          >
                          {{ list.name }}
                          </button>
                          </div>
                          </template>
                          </t-dropdown> 
                        -->
                      </div>
                      <div class="w-24 capitalize">
                        <InfoChip
                          :text="
                            getSubscriberStatusChipConfig(item.status).text
                          "
                          :color="
                            getSubscriberStatusChipConfig(item.status).color
                          "
                        />
                      </div>
                      <div
                        class="flex flex-shrink-0 items-center justify-end text-right"
                      >
                        <button
                          class="mr-2"
                          @click="showModal('cw-stats', index)"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            class="w-4 h-4 text-truegray-300 hover:text-primary"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </button>
                        <button
                          class="mr-2"
                          @click="showModal('cw-update', index)"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            class="w-4 h-4 text-truegray-300 hover:text-primary"
                          >
                            <path
                              d="M2.695 14.763l-1.262 3.154a.5.5 0 00.65.65l3.155-1.262a4 4 0 001.343-.885L17.5 5.5a2.121 2.121 0 00-3-3L3.58 13.42a4 4 0 00-.885 1.343z"
                            />
                          </svg>
                        </button>
                        <button
                          @click="
                            () => toggleShowSubscriberBulkActions(item.id)
                          "
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            class="w-4 h-4 text-truegray-300 hover:text-primary"
                          >
                            <path
                              d="M3 10a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM8.5 10a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM15.5 8.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
                            />
                          </svg>
                        </button>
                        <div
                          :class="[
                            'absolute right-0 top-0 z-10 h-full transition-all duration-150 ease-in-out',
                            item.showBulkActions
                              ? 'px-4 flex flex-row items-center bg-white border-l border-b border-t rounded-l-md w-auto'
                              : 'w-0',
                          ]"
                        >
                          <button
                            :class="[
                              'mr-3',
                              item.showBulkActions ? 'visible' : 'hidden',
                            ]"
                            @click="showModal('cw-stats', index)"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                              class="w-4 h-4 text-truegray-300 hover:text-primary"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z"
                                clip-rule="evenodd"
                              />
                            </svg>
                          </button>
                          <button
                            :class="[
                              'mr-3',
                              item.showBulkActions ? 'visible' : 'hidden',
                            ]"
                            @click="showModal('cw-update', index)"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                              class="w-4 h-4 text-truegray-300 hover:text-primary"
                            >
                              <path
                                d="M2.695 14.763l-1.262 3.154a.5.5 0 00.65.65l3.155-1.262a4 4 0 001.343-.885L17.5 5.5a2.121 2.121 0 00-3-3L3.58 13.42a4 4 0 00-.885 1.343z"
                              />
                            </svg>
                          </button>
                          <!-- <div > -->
                          <button
                            v-for="(opt, actionIndex) in subscribersBulkActions"
                            :key="actionIndex"
                            :class="[
                              'mr-3',
                              item.showBulkActions ? 'visible' : 'hidden',
                            ]"
                            @click="() => dispatchAction(opt.action, index)"
                          >
                            <span v-html="opt.icon" />
                          </button>
                          <button
                            :class="[
                              item.showBulkActions ? 'visible' : 'hidden',
                            ]"
                            @click="
                              () =>
                                toggleShowSubscriberBulkActions(item.id, false)
                            "
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                              class="w-5 h-5 text-truegray-300 hover:text-primary"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                                clip-rule="evenodd"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </DynamicScrollerItem>
              </template>
            </DynamicScroller>
            <div v-else-if="isCateRegionalAdmin" class="p-4">
              <t-alert show :dismissible="false" variant="error">
                You do not have permission to view subscribers.
              </t-alert>
            </div>
            <div v-else class="p-4">
              <t-alert show :dismissible="false" variant="error">
                No subscribers found.
              </t-alert>
            </div>
          </div>
        </template>
        <div v-else class="w-full h-14">
          <lottie :options="loadingAnimationOptions" />
        </div>
      </div>
      <!-- /Table -->
    </div>
    <!-- /Page -->
  </div>
</template>

<script>
import { defineComponent, computed, watch, ref, onMounted } from 'vue'
import { useStore } from '../../../../../js/store/index.js'
import { EventBus } from '../../../../../js/plugins/event-bus.js'
import {
  pluraliseString,
  getDateFormatted,
  checkPositiveInteger,
} from '../../../../../js/util/helper.js'
import * as loadingAnimation from '../../../../../shared/components/loading-dark.json'
import TabLists from './TabLists.vue'
import InfoChip from '../../../../../shared/components/InfoChip.vue'
import TextInput from '../../../../../shared/components/InputText.vue'
import InputDropdownExpanding from '../../../../../shared/components/InputDropdownExpanding.vue'

export default defineComponent({
  name: 'Subscribers',

  components: {
    TabLists,
    // Subscribers,
    InfoChip,
    TextInput,
    InputDropdownExpanding,
  },

  emits: ['set-loaded-data'],

  setup(props, { emit }) {
    const store = useStore()

    // setup
    const loadingAnimationOptions = { animationData: loadingAnimation.default }
    const loadedData = ref(false)
    const isCateRegionalAdmin = computed(() => {
      return store.getters['shared/isCateRegionalAdmin']
    })

    // views
    const views = [
      {
        key: 'subscriber',
        title: 'subscribers',
        searchPlaceholder: 'Subscriber email',
      },
      {
        key: 'list',
        title: 'lists',
        searchPlaceholder: 'Subscriber email',
      },
    ]
    const activeViewId = ref(null)
    const viewTitle = computed(() => {
      return views[activeViewId.value]?.title
    })

    const toggleView = () => {
      activeViewId.value = +!activeViewId.value
    }

    const routeTo = (listId) => {
      activeListId.value = listId
      toggleView()
    }

    const dispatchAction = async (action, index) => {
      const subscriber = filteredSubscribers.value[index]
      if (subscriber) {
        return await actions[action](subscriber)
      }
      return await actions[action]()
    }

    watch(activeViewId, () => {
      init(false, true)
    })

    // queue alert
    const showAlert = ref(false)
    const toggleAlert = (value = !showAlert.value) => {
      showAlert.value = value
    }

    // subscribers
    const followers = computed(() => {
      return store.getters['careerwise/getFollowers']
    })
    const subscribers = ref([])
    const subscribersCount = computed(() => {
      return store.getters['careerwise/getFollowersCount']
    })
    const subscribersCountLimit = computed(() => {
      return store.getters['careerwise/getPlanLimitations']?.maxFollowers
    })
    const subscribersCountClasses = computed(() => {
      return store.getters['careerwise/getFollowersCountClasses']()
    })
    const subscribersHeaders = [
      {
        value: 'selected',
        text: '',
        sort: false,
        class: 'w-6 flex-shrink-0 mr-4',
        isHail: false,
      },
      {
        value: 'email',
        text: 'Email',
        sort: true,
        class: 'w-4/12 flex-shrink-0',
        isHail: true,
      },
      {
        value: 'createdAt',
        text: 'Created on',
        sort: true,
        class: 'w-24 flex items-center justify-center flex-shrink-0',
        isHail: false,
      },
      {
        value: 'lists',
        text: 'Lists',
        sort: false,
        class: 'w-60 flex items-center justify-center flex-shrink-0',
        isHail: false,
      },
      {
        value: 'status',
        text: 'Status',
        sort: true,
        class: 'w-24 flex items-center justify-center flex-shrink-0',
        isHail: true,
      },
      {
        value: 'actions',
        text: 'Actions',
        sort: false,
        class: 'flex items-center justify-end flex-shrink-0',
        isHail: false,
      },
    ]
    const subscribersBulkActions = [
      {
        name: 'delete',
        title: 'Delete',
        action: 'deleteSubscribers',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-4 h-4 text-truegray-300 hover:text-primary">
            <path fill-rule="evenodd" d="M8.75 1A2.75 2.75 0 006 3.75v.443c-.795.077-1.584.176-2.365.298a.75.75 0 10.23 1.482l.149-.022.841 10.518A2.75 2.75 0 007.596 19h4.807a2.75 2.75 0 002.742-2.53l.841-10.52.149.023a.75.75 0 00.23-1.482A41.03 41.03 0 0014 4.193V3.75A2.75 2.75 0 0011.25 1h-2.5zM10 4c.84 0 1.673.025 2.5.075V3.75c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v.325C8.327 4.025 9.16 4 10 4zM8.58 7.72a.75.75 0 00-1.5.06l.3 7.5a.75.75 0 101.5-.06l-.3-7.5zm4.34.06a.75.75 0 10-1.5-.06l-.3 7.5a.75.75 0 101.5.06l.3-7.5z" clip-rule="evenodd" />
          </svg>`,
      },
      // {
      //   name: 'add',
      //   title: 'Add to list',
      //   action: 'updateSubscriberLists'
      // }
    ]
    const subscribersBulkActionsText = computed(() => {
      const count = selectedSubscribers.value.length
      return `${count} ${pluraliseString('subscriber', count)} selected`
    })
    const toggleShowSubscriberBulkActions = (id, val = true) => {
      // reset any open bulk actions modals
      subscribers.value = [
        ...subscribers.value.map((sub) => {
          return { ...sub, showBulkActions: false }
        }),
      ]
      const subscriber = subscribers.value.find(
        (subscriber) => subscriber.id === id,
      )
      if (subscriber) {
        subscriber.showBulkActions = val
        subscribers.value = [...subscribers.value] // trigger reactivity!
      }
    }

    const selectedSubscribers = computed(() => {
      return filteredSubscribers.value.filter(
        (subscriber) => !!subscriber.selected,
      )
    })

    const getSubscriberStatusChipConfig = (val) => {
      const color =
        val === 'bounced' || val === 'unsubscribed' || val === 'unlisted'
          ? 'red'
          : val === 'subscribed'
          ? 'green'
          : undefined
      return {
        text: val || 'subscribed',
        color,
      }
    }

    const toggleSelectSubscriber = (index) => {
      const subscriber = {
        ...subscribers.value[index],
        selected: !subscribers.value[index].selected,
      }

      subscribers.value[index] = subscriber

      if (!subscriber.selected) {
        selectAll.value = false
      }
    }

    const setSelectAll = (val = !selectAll.value) => {
      selectAll.value = val

      const subs = subscribers.value.map((subscriber) => {
        return {
          ...subscriber,
          selected: val,
        }
      })

      subscribers.value = subs
    }

    const actions = {
      deleteSubscribers: (subscriber) => {
        let data = []
        if (subscriber) {
          // single subscriber delete
          data = [subscriber]
        } else {
          // bulk subscriber delete
          data = selectedSubscribers.value
        }

        showModal('cw-delete', data)
      },
    }

    const updateSubscriberLists = (subscriber) => {
      let data = []
      if (subscriber) {
        // single subscriber delete
        data = [subscriber]
      } else {
        // bulk subscriber delete
        data = selectedSubscribers.value
      }

      showModal('cw-update', data)
    }

    watch(followers, () => {
      subscribers.value = followers.value
    })

    // filtering/searching/sorting/state
    const selectAll = ref(false)
    const sortBy = ref(null)
    const sortDesc = ref(false)
    const searchFilter = ref('')
    const includeSearchFilter = ref(true)
    const filtersOpen = ref(false)
    const FILTER_SUBSCRIBERS_BY_DEFAULT_VALUES = {
      status: null,
      lists: [],
    }
    const filterSubscribersBy = ref({
      status: FILTER_SUBSCRIBERS_BY_DEFAULT_VALUES.status,
      lists: FILTER_SUBSCRIBERS_BY_DEFAULT_VALUES.lists,
    })

    const subscriberStatusOptions = computed(() => {
      return store.getters['careerwise/getFollowerStatusOptions']
    })

    const searchFilterPlaceholder = computed(() => {
      return views[activeViewId.value]?.searchPlaceholder
    })

    const filtersCount = computed(() => {
      const obj = filterSubscribersBy.value
      return Object.entries(obj).reduce((count, [_key, value]) => {
        if (value !== null && (!Array.isArray(value) || value.length > 0)) {
          return count + 1
        }
        return count
      }, 0)
    })

    const setIncludeSearchFilter = (val) => {
      includeSearchFilter.value = val
    }

    const sortSubscribersColumn = () => {
      const sortB = sortBy.value
      const sortD = sortDesc.value ? 1 : -1

      if (!sortB) {
        return
      }

      const subs = [...subscribers.value].sort((a, b) => {
        const A = a[sortB],
          B = b[sortB]

        if (typeof A === 'number') {
          return sortD * (B - A)
        }

        return sortD * A.localeCompare(B)
      })

      subscribers.value = subs
    }

    const setSubscribersColumnSortBy = (val) => {
      if (sortBy.value !== val) {
        // sort by different column;
        // reset sortDesc
        sortBy.value = val
        sortDesc.value = false
      } else {
        // sort by same column;
        // just toggle sortDesc
        sortDesc.value = !sortDesc.value
      }

      sortSubscribersColumn()
    }

    const setFiltersOpen = (val = !filtersOpen.value) => {
      filtersOpen.value = val
    }

    const filterSubscribers = (sub) => {
      const filter = searchFilter.value?.toLowerCase()?.trim()
      const listsFilterIds = filterSubscribersBy.value.lists // ids of lists selected
      const statusFilterKey = filterSubscribersBy.value.status // magic id of status selected - see store
      const statusOpt = subscriberStatusOptions.value.find(
        (opt) => opt.value === statusFilterKey,
      )
      const statusKey = statusOpt?.key
      const searchIndex = sub.email?.toLowerCase().indexOf(filter)
      const subListIds = sub.lists.map((list) => list.id)

      const verified =
        (searchFilter.value
          ? includeSearchFilter.value
            ? searchIndex > -1
            : searchIndex < 0
          : true) &&
        (checkPositiveInteger(statusFilterKey)
          ? sub.status === statusKey
          : true) &&
        listsFilterIds.every((listId) => subListIds.includes(listId))

      return verified
    }

    const filteredSubscribers = computed(() => {
      return subscribers.value?.filter(filterSubscribers)
    })

    const initFilters = () => {
      for (const [key] of Object.entries(filterSubscribersBy.value)) {
        filterSubscribersBy.value[key] =
          FILTER_SUBSCRIBERS_BY_DEFAULT_VALUES[key]
      }

      EventBus.$emit('resetInputDropdownExpanding')
      EventBus.$emit('closeFilterDropdowns')
    }

    watch(filterSubscribersBy, () => {
      setSelectAll(false)
    })

    watch(searchFilter, () => {
      setSelectAll(false)
    })

    // lists
    const activeListId = ref(null)
    const mailListInputOptions = computed(() => {
      return store.getters['careerwise/getMailListInputOptions']()
    })

    const resetActiveList = () => {
      activeListId.value = null
    }

    const showModal = (type, data) => {
      const key = views[activeViewId.value]?.key
      if (key) {
        type = `${type}-${key}`

        const config = {}

        // (bulk) delete subscriber(s)
        if (type === 'cw-delete-subscriber') {
          config.subscribers = data
          ;(config.title = pluraliseString('Delete subscriber', data.length)),
            (config.subtitle = `Are you sure you want to delete the following ${pluraliseString(
              'subscriber',
              data.length,
            )}?`)
          config.action = 'delete'
        }

        // subscriber statistics
        else if (type === 'cw-stats-subscriber') {
          const subscriber = filteredSubscribers.value[data]
          config.subscriber = subscriber
        }

        // create subscriber, update subscriber
        else {
          // if we have a valid index, we are updating a single subscriber
          // otherwise we are creating one (use modal defaults)
          if (checkPositiveInteger(data)) {
            const subscriber = filteredSubscribers.value[data]
            if (subscriber) {
              config.title = 'Update subscriber'
              config.subscriber = subscriber
              config.action = 'update'
            }
          }

          // // otherwise we are updating multiple subscribers (adding to lists)
          // else if (!!data?.length) {
          //   config.title = `Add subscribers to lists`
          //   config.subtitle = 'The following subscribers will be added to your selected lists'
          //   config.subscribers = data
          //   config.action = 'lists'
          // }
        }

        EventBus.$emit('showModal', {
          action: type,
          data: config,
        })
      }
    }

    const init = async (resetList = true, initHail = false) => {
      emit('set-loaded-data', false)
      sortBy.value = null
      sortDesc.value = false
      searchFilter.value = ''
      setIncludeSearchFilter(true)
      setSelectAll(false)
      initFilters()
      toggleAlert(false)

      // always update followers and lists - both need each other!
      loadedData.value = false
      await store.dispatch('careerwise/dispatchInitFollowers', initHail)

      if (resetList) {
        // don't reset if routing from Subscriber view via Lists dropdown
        resetActiveList()
      }

      loadedData.value = true
      emit('set-loaded-data', true)
    }

    onMounted(() => {
      activeViewId.value = 1

      EventBus.$on('updateSubscribersSearchFilter', (val) => {
        searchFilter.value = val
      })

      EventBus.$on('updateSubscribersFilterByStatus', (val) => {
        filterSubscribersBy.value.status = val
      })

      EventBus.$on('updateSubscribersFilterByLists', (val) => {
        filterSubscribersBy.value.lists = val
      })

      // @todo handle API success in the store
      EventBus.$on('initSubscribers', async (activeListId) => {
        await init()
        if (activeListId) {
          EventBus.$emit('setActiveListId', activeListId)
        }
      })

      EventBus.$on('triggerListAlert', (value = true) => {
        if (!activeViewId.value) {
          toggleAlert(value)
        }
      })
    })

    return {
      getDateFormatted,
      loadingAnimationOptions,
      loadedData,
      isCateRegionalAdmin,
      views,
      activeViewId,
      viewTitle,
      toggleView,
      selectedSubscribers,
      filteredSubscribers,
      subscribersCount,
      subscribersCountLimit,
      subscribersCountClasses,
      setSelectAll,
      selectAll,
      setIncludeSearchFilter,
      sortBy,
      sortDesc,
      subscribersHeaders,
      subscribersBulkActions,
      subscribersBulkActionsText,
      getSubscriberStatusChipConfig,
      toggleSelectSubscriber,
      toggleShowSubscriberBulkActions,
      updateSubscriberLists,
      searchFilterPlaceholder,
      filtersCount,
      setSubscribersColumnSortBy,
      setFiltersOpen,
      resetActiveList,
      init,
      searchFilter,
      includeSearchFilter,
      filtersOpen,
      subscriberStatusOptions,
      mailListInputOptions,
      initFilters,
      routeTo,
      dispatchAction,
      activeListId,
      showModal,
      showAlert,
      toggleAlert,
    }
  },
})
</script>
